import { IconButton, styled } from "@material-ui/core";
import { Person } from "@material-ui/icons";
import { useState } from "react";
import { UserContextDrawer } from "./user-context-drawer";

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text
}))

export const ProfileInfoComponent = ({ ...props }) => {

  const [open, setOpen] = useState(false)
  const toggleOpen = () => setOpen(!open)

  return (
    <>
      <StyledIconButton onClick={toggleOpen}><Person /></StyledIconButton>
      <UserContextDrawer open={open} onClose={toggleOpen} />
    </>
  )
}